import React from 'react';

import NotificationShow from '@components/shared/notifications/NotificationShow';

import { notificationService } from '@services/admin/notificationService';

/**
 * Admin 通知詳情頁面
 */
export default function AdminNotificationShow() {
  return (
    <NotificationShow
      service={notificationService}
      role="admin"
    />
  );
}
